import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import ThreatModelerCredentialsForm from "./ThreatModelerCredentialsForm";
import ThreatModelerMappingForm from "./ThreatModelerMappingForm";

const ThreatModelerConfigListing = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Threat Models",
        dataIndex: "projectName",
        width: 130,
        render: columnRenderArrayData,
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={ThreatModelerMappingForm}
      CredentialsForm={ThreatModelerCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default ThreatModelerConfigListing;